<template>
  <div>
    <div v-loading="loading">
      <div v-if="detailData">
        <el-card shadow="hover">
          <goods-sku-info :imageSize="80" :skuInfo="detailData" />
        </el-card>
        <div>
          <x-tab :tabs="tabs" :query="detailData" :params="detailData" />
        </div>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small">
          重新加载
        </el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import goodsSkuInfo from '../../../../components/business/goodsSkuInfo.vue'
import WarehouseGoodsInfo from '../../../../components/business/warehouseGoodsInfo.vue';
import tabStoreGoods from "./_detail_tab_goods.vue";
import tabStoreOrder from "./_detail_tab_order.vue";

export default {
  components: {
    goodsSkuInfo,
    WarehouseGoodsInfo,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tabs() {
      if (!this.detailData) {
        return;
      }
      return [
        {
          name: "store-goods",
          label: "覆盖门店",
          component: tabStoreGoods,
          interval: true,
        },
        {
          name: "store-order",
          label: "相关订单",
          component: tabStoreOrder,
          interval: true,
        },
      ];
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params,
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query,
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      detailData: null
    };
  },
  methods: {
    getDetail() {
      this.errorMsg = null;
      this.detailData = null;
      this.loading = true;
      return this.requestApi('biz.goods.sku.info.detail', {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid
      }).then((resp) => {
        this.loading = false;
        this.detailData = resp.data;
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || (err && err.message)
          || '连接服务器失败，请检查网络';
      });
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>
